angular.module('cfn').directive('cfnImportLifecycle', [
  '$rootScope',
  '$log',
  '$filter',
  function($rootScope, $log, $filter) {
    return {
      restrict: 'E',
      scope: {
        ctrl: '='
      },
      templateUrl: require('./cfn-import-lifecycle.tpl.html'),
      link: function(scope) {
        scope.$rootScope = $rootScope;

        ang.overrideFunction(scope.ctrl, 'onShowDetails', function(
          oldShowDetails
        ) {
          oldShowDetails();
          if (scope.ctrl.details && scope.ctrl.details.field) {
            var field = scope.ctrl.details.field;

            var item = {};
            var succ = [
              'successorOne',
              'predecessorOne',
              'successorTwo',
              'predecessorTwo'
            ];

            $.each(succ, function(i, key) {
              if (field[key]) {
                item[key] = {};
                item[key].text =
                  "<a class='fieldHistoryLink' href='#/core/field/" +
                  field[key].id +
                  "'>" +
                  field[key].number +
                  '</a>';
              }
            });
            item.validFrom = {
              text: $filter('date')(field.validFrom, 'mediumDate')
            };
            scope.item = item;
          } else scope.item = null;
        });
      }
    };
  }
]);
